import { teApi, dmpApi } from 'yxt-biz-pc/packages/api';
// import axios from 'axios';

// 4.3-获取我的团队列表
export const getTeamList = (teamId) => {
  return teApi.get(`mt/common/team/list?teamId=${teamId || ''}`);
};

// 获取团队下的部门
export const getTeamDeptsList = async(data) => {
  const res = await dmpApi.post('/team/component/dept', data);
  if (!res) return [];
  if (res.datas) return res;
  if (Array.isArray(res)) {
    return {
      datas: res
    };
  };
  return {
    datas: [res]
  };
};

// // 5.1-获取我的团队部门列表
// export const getTeamDeptsList = (params) => {
//   return dmpApi.post('/team/component/dept', data);
//   return axios.post(`${window.feConfig.common.apiBaseUrl}dmp/team/component/dept`, params,
//     {
//       headers: {
//         source: 501,
//         'Content-Type': 'application/json;charset=UTF-8',
//         token: localStorage.getItem('token')
//       }
//     }
//   );
// };
